import React, { Dispatch, SetStateAction } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@printdeal/ui-library';

import OpenDeliveryToolButton from '../../OpenDeliveryToolButton';
import { SanitizedLineItem } from '../../../../../../../../types/order/Order';
import { DeliveryToolSettings } from '../../../../../../../../types/file-delivery/FileDelivery';

interface ChooseUploaderProps {
  lineItem: SanitizedLineItem;
  orderId: string;
  deliveryToolSettings: DeliveryToolSettings;
  setChosenDeliveryMethod: Dispatch<SetStateAction<boolean>>;
  deliveryMethod: string;
}

const ChooseUploader = ({
  lineItem,
  orderId,
  deliveryToolSettings,
  setChosenDeliveryMethod,
  deliveryMethod,
}: ChooseUploaderProps) => (
  <OpenDeliveryToolButton
    lineItem={lineItem}
    orderId={orderId}
    deliveryToolSettings={deliveryToolSettings}
    chosenDeliveryMethod={deliveryMethod}
  >
    <Button
      type="submit"
      variant="dim"
      iconBefore="file"
      iconAfter="chevron-right"
      onClick={() => {
        setChosenDeliveryMethod(true);
      }}
      className="pd-flex pd-w-full"
    >
      <FormattedMessage
        id="delivery.tool.ownFiles.odp"
        defaultMessage="Upload your own file(s)"
      />
    </Button>
  </OpenDeliveryToolButton>
);

export default ChooseUploader;
